(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-logo-list"] && !Shopify.designMode) return;
  try {
    
$('.logo-list_wrap').slick({
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews-columns"] && !Shopify.designMode) return;
  try {
    
$('.reviews-columns_wrap').slick({
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-slider-02"]) return;
  try {
    
$('.slider_wrap').slick({
infinite: true,
speed: 500,
slidesToShow: 1,
slidesToScroll: 1
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-slider"]) return;
  try {
    
$('.slider_wrap').slick({
infinite: true,
speed: 500,
slidesToShow: 1,
slidesToScroll: 1
});

  } catch(e) { console.error(e); }
})();
})();
